import { createSubmission as createSubmissionRequest } from '@wix/ambassador-forms-v4-submission/http';
import { SubmissionStatus, } from '@wix/ambassador-forms-v4-submission/types';
export const submitForm = ({ httpClient, requestCaptcha }) => async (formId, values) => {
    const submission = {
        formId,
        submissions: values,
        status: SubmissionStatus.PENDING, // TODO: remove when backend fixes this
    };
    const captchaToken = await requestCaptcha();
    const response = await httpClient.request(createSubmissionRequest({ submission, captchaToken }));
    return {
        ...response.data,
    };
};
//# sourceMappingURL=submit-form.js.map